var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaAbajoActivo24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43051 8.70198C4.70003 8.38745 5.1735 8.35097 5.48803 8.62049L11.7112 13.9532C11.8793 14.0989 12.1207 14.0989 12.2888 13.9532L12.292 13.9505L18.512 8.62049C18.8265 8.35097 19.3 8.38745 19.5695 8.70198C19.839 9.01651 19.8026 9.48998 19.488 9.75951L13.2712 15.0868L13.2694 15.0883C12.5381 15.7206 11.4618 15.7206 10.7306 15.0883L4.512 9.75951C4.19747 9.48998 4.16098 9.01651 4.43051 8.70198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaAbajoActivo24X24);
export default __webpack_public_path__ + "static/media/FLECHA_ABAJO_ACTIVO_24X24.5f34fbc17e95a17b58ce94f36cc6e8c8.svg";
export { ForwardRef as ReactComponent };